/**
 * 替换 URL 中的域名
 * @param url - 原始 URL
 * @param newDomain - 新的域名（不带协议）
 * @returns 替换域名后的新 URL
 */
export function replaceDomain(url: string, newDomain: string): string {
  try {
    // 解析 URL
    const parsedUrl = new URL(url);

    // 替换域名
    parsedUrl.hostname = newDomain;

    return parsedUrl.toString();
  } catch (error) {
    console.error("Invalid URL provided:", error);
    throw new Error("Invalid URL");
  }
}

/**
 * 追加 URL 参数
 * @param url - 原始 URL
 * @param query - 参数
 * @returns 追加参数后的新 URL
 */
export function appendQuery(url: string, query: string): string {
  return url + (url.includes('?') ? '&' : '?') + query;
}

/**
 * 检测URL是否是随机路径
 * 随机路径特征：包含日期/随机字符/尺寸，如：20250723/qDUg/4096X3072
 * @param url - 要检测的URL
 * @returns 是否是随机路径
 */
export function isRandomPath(url: string): boolean {
  // 正则表达式匹配：日期(8位数字)/随机字符(4位或更多字母数字)/尺寸(数字X数字)
  const randomPathPattern = /\/\d{8}\/[a-zA-Z0-9]{4,}\/\d+X\d+/;
  return randomPathPattern.test(url);
}

/**
 * 验证字符串是否是有效的URL
 * @param string - 要验证的字符串
 * @returns 是否是有效的URL
 */
export function isValidUrl(string: string): boolean {
  try {
    const url = new URL(string);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (_) {
    return false;
  }
}